import { Box } from '@chakra-ui/react'
import { LOCAL_ZINDEX } from 'presentation/screens/CompsScreen/components/CompScreenBase/CompsScreenBase.const'
import { PropsWithChildren } from 'react'

export const WithScrollableCompsMapBehavior = ({ children }: PropsWithChildren) => (
  <Box h='full' zIndex={LOCAL_ZINDEX.MAP}>
    {children}
  </Box>
)
